"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _classNames = _interopRequireDefault(require("../classNames"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["className", "field", "object", "options"];
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/InputJson/index.js";
var defaultProps = {
  object: {},
  type: 'text'
};
function InputJson(_ref) {
  var className = _ref.className,
    field = _ref.field,
    object = _ref.object,
    options = _ref.options,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _React$useState = _react["default"].useState(JSON.stringify(object[field], null, 4) || ''),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  function onInput(event) {
    var value = event.target.value;
    setValue(value);
    try {
      event.target.setCustomValidity("");
      if (object[field]) {
        Object.assign(object[field], JSON.parse(value));
      } else {
        object[field] = JSON.parse(value);
      }
    } catch (error) {
      console.log(error.message);
      event.target.setCustomValidity(error.message);
    }
  }
  return /*#__PURE__*/_react["default"].createElement("textarea", Object.assign({
    defaultValue: value,
    className: (0, _classNames["default"])('form-control', className),
    name: field,
    onInput: onInput
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 9
    }
  }));
}
InputJson.defaultProps = defaultProps;
var _default = InputJson;
exports["default"] = _default;